import {
  ECommunityCode,
  ECountryCode,
  ELanguageCode,
  ILanguage,
  ICurrency,
  IPaymentConfig
} from "features/common";

export interface ISignupConfig {
  communityCode: ECommunityCode;
  currency: ICurrency;
  defaultCountry: ECountryCode;
  language: ILanguage;
  enableLanguageSwitch: boolean;
  paymentConfig: IPaymentConfig;
  supportedLanguages?: ELanguageCode[];
}

export interface ISignupConfigMap extends Record<ECommunityCode, ISignupConfig> {}

export const UK_SIGNUP_CONFIG: ISignupConfig = {
  communityCode: ECommunityCode.UK,
  currency: {
    code: "GBP",
    symbol: "£",
    locale: "en-GB"
  },
  language: {
    id: 1,
    code: "en",
    label: "English"
  },
  defaultCountry: ECountryCode.GB,
  enableLanguageSwitch: false,
  paymentConfig: {
    termsAndConditionsLink: "https://www.constructionline.co.uk/terms-conditions",
    termOfUseLink: "https://onceforall.com/terms/#TermsofUse",
    privacyPolicyLink: "https://onceforall.com/terms/#Privacy",
    stripePrivacyPolicyLink: "https://stripe.com/gb/privacy",
    stripePublishableKey: window.appConfig.stripeUKPublishableKey,
    billingEmail: "billing@onceforall.com"
  }
};

export const FR_SIGNUP_CONFIG: ISignupConfig = {
  communityCode: ECommunityCode.FR,
  currency: {
    code: "EUR",
    symbol: "€",
    locale: "fr-FR"
  },
  language: {
    id: 2,
    code: "fr",
    label: "French"
  },
  defaultCountry: ECountryCode.FR,
  enableLanguageSwitch: true,
  supportedLanguages: [ELanguageCode.EN, ELanguageCode.FR],
  paymentConfig: {
    termsAndConditionsLink: "https://onceforall.fr/informations-legales/",
    termOfUseLink: "https://onceforall.fr/informations-legales/",
    privacyPolicyLink: "https://onceforall.fr/politique-de-confidentialite/",
    stripePrivacyPolicyLink: "https://stripe.com/fr/privacy",
    stripePublishableKey: window.appConfig.stripeFRPublishableKey,
    billingEmail: "billing@onceforall.com"
  }
};

export const SIGNUP_CONFIG_MAP: ISignupConfigMap = {
  [ECommunityCode.UK]: UK_SIGNUP_CONFIG,
  [ECommunityCode.FR]: FR_SIGNUP_CONFIG
};

export const getSignupConfig = (communityCode?: ECommunityCode): ISignupConfig => {
  return SIGNUP_CONFIG_MAP[communityCode || ECommunityCode.UK];
};
